// extracted by mini-css-extract-plugin
export default {"fontFamilyClux":"\"Clux\",\"Roboto\",\"Helvetica\",\"Arial\",sans-serif"};